"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function FileExcelTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'file-excel',
    theme: 'twotone',
    nameWithTheme: 'file-excel-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M534 352V136H232v752h560V394H576c-23.2 0-42-18.8-42-42zm51.6 120h35.7c6.6 0 12 5.4 12 12 0 2.3-.7 4.6-1.9 6.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5c-6.6 0-12-5.4-12-12 0-2.3.6-4.5 1.8-6.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216c0 23.2 18.8 42 42 42h216v494z',
        fill: primaryColor
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8c-1.2 1.9-1.8 4.1-1.8 6.4 0 6.6 5.4 12 12 12h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5c1.2-1.9 1.9-4.2 1.9-6.5 0-6.6-5.4-12-12-12h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z',
        fill: primaryColor
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'file-excel-twotone';
var FileExcelTwoTone = temp;
exports.default = FileExcelTwoTone;